<template>
  <div v-loading="loading">
    <template>
      <Header />
      <div class="page">
        <KF></KF>
        <router-view></router-view>
      </div>
      <Footer v-if="$route.meta.isHome" />
      <Footer2 v-if="!$route.meta.isHome" />
    </template>
  </div>
</template>

<script>
import Cookies from "js-cookie"
import Header from "../components/share/Header"
import Footer from "../components/share/Footer"
import Footer2 from "../components/share/Footer2"
import KF from "../components/share/KeFuWeiXin"
import { mapActions, mapMutations } from "vuex";
import Utils from "../assets/script/utils/util.js";

export default {
  name: "Content",
  data() {
    return {
      loading: false
    }
  },
  components: {
    Header,
    Footer,
    Footer2,
    KF
  },
  ...mapMutations("user", ["MSet"]),
  async created() {
    if (window.wechart) {
      //正在登录
      let result = await this.ALogin({ code: window.wechart.code });

      // //先清空cookie
      // Cookies.remove("user");
      // this.MSet(null);

      //正在登录进度取消
      if (result.errorCode) {
        this.$notify({ message: result.errorMess });
        return
      }
      else {
        var exp = new Date();
        exp.setTime(exp.getTime() + 99999 * 24 * 60 * 60 * 1000);

        Cookies.set("user", JSON.stringify(result.data), { expires: exp });
        //模拟返回慢
        // await this.sleep(1800)
        let user = result.data;
        // console.log('user/MSet:' + JSON.stringify(user.userInfo));
        // this.MSet(user.userInfo);

        await this.$store.commit("user/MSet", user.userInfo);
        // console.log('同步操作version test not mset ')
        // Utils.$emit("getPatternList");
      }


    } else {
      // console.log('create else');
      if (Cookies.get("user")) {
        // let user = JSON.parse(Cookies.get("user"));
        // this.MSet(user.userInfo)
        //过期不添加userinfo
        let userObj = JSON.parse(Cookies.get("user"));

        let user = Cookies.get("user");
        var data = this.dateFormat(new Date());

        if (user && JSON.parse(user).userInfo.tokenEndTime) {
          let tokenEndTime = JSON.parse(user).userInfo.tokenEndTime;

          //对比日期大小，第一个参数大于第二个参数则返回true
          var compareDateValue = this.compareDate(this.dateFormat(data), this.dateFormat(tokenEndTime));
          if (!compareDateValue) {
            this.MSet(userObj.userInfo)
          }
          else {
            if (this.$route.path.indexOf('wordfrequency') > -1) {
              this.$alert("请先进行登录后再操作");
            }
          }
        }

      } else {
        if (this.$route.path.indexOf('wordfrequency') > -1) {
          //词云生成界面才需要弹出登录提示
          this.$alert("请先进行登录后再操作");
        }

      }
    }
  },
  methods: {
    ...mapActions("user", ["ALogin"]),
    ...mapMutations("user", ["MSet"]),
    sleep(d) {
      return new Promise((resolve) => setTimeout(resolve, d))
    },
    formatTime(date) {
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      month = month < 10 ? '0' + month : month;
      var day = date.getDate();
      day = day < 10 ? '0' + day : day;
      return year + '-' + month + '-' + day;
    },
    dateFormat(time) {
      var date = new Date(time);
      var year = date.getFullYear();
      /* 在日期格式中，月份是从0开始的，因此要加0
       * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
       * */
      var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
      var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      var minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      var seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      // 拼接
      return year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
    },
    compareDate(d1, d2) {
      let reg = new RegExp('-', 'g')
      return ((new Date(d1.replace(reg, '/'))) > (new Date(d2.replace(reg, '/'))))
    },
  }
}
</script>

<style type="text/less" lang="less" scoped>
</style>
